import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import type { MediaItem } from "@/modules/common/media/mediaTypes"
import { cn } from "@/modules/lib/utils"
import type { SessionMediaItemEntity } from "@/modules/sessions/entities/sessionBlockMediaEntity"
import { word } from "@modules/core/utils/i18n"
import { DownloadIcon } from "lucide-react"
import { Link } from "react-router"

type MediaDetailsImageProps = {
  media: SessionMediaItemEntity | MediaItem
  className?: string
} & React.ComponentProps<"div">

export function MediaDetailsImage({ media, className, ...props }: MediaDetailsImageProps) {
  return (
    <div
      className={cn("relative flex h-full w-full flex-1 flex-col items-center justify-center", className)}
      {...props}
    >
      {media.url ? (
        <img src={media.url} alt="media" style={{ maxWidth: "100%", maxHeight: "100%" }} />
      ) : (
        <Text fontStyle="BM" className="wrap-break-word">
          {word("sessionForm.blocks.add_media.missing_error")}
        </Text>
      )}

      <Link to={media.url} target="_blank">
        <Button variant="ghost" size="iconMd" className="absolute top-0 right-0 m-auto mt-3 mr-3">
          <DownloadIcon size={24} color="currentColor" className="text-textDefault-body" />
        </Button>
      </Link>
    </div>
  )
}
